import { render, staticRenderFns } from "./excel2.vue?vue&type=template&id=2a5b1af0&"
import script from "./excel2.vue?vue&type=script&lang=js&"
export * from "./excel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports